<ng-container *ngIf="contentlet$ | async as contentlet">
  <div class="dot-cms-html-content default-web-page-content-class">
    <ng-container *ngIf="setAttribute; else useDirective">
      <custom-dot-editable-text
        [fieldName]="'body'"
        [contentlet]="contentlet"
        [format]="'html'"
        [mode]="'full'"
      ></custom-dot-editable-text>
    </ng-container>
  </div>

  <ng-template #useDirective>
    <div
      dotCmsSetAttributes
      [identifier]="contentlet.identifier"
      [mode]="'full'"
      [fieldName]="'body'"
      [setAttribute]="setAttribute"
      class="dot-cms-html-content default-web-page-content-class"
      [ishServerHtml]="contentlet.body"
    ></div>
  </ng-template>
</ng-container>
